import { useEffect, useMemo } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import {
  useGetProtectedApiDataQuery,
  useGetProtectedApiHtmlQuery,
} from "../../redux/services/apiSlice";
import { getLastUpdatedOn } from "../../Utils/apiFunctions";

const AboutNeepcoPage = () => {
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const { data: lastUpdatedOnData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({
      url: "basic_page",
      lang: languageType,
    });

  // last updated on

  const { data: aboutUsHtml = {}, isLoading: aboutUsHtmlIsLoading } =
    useGetProtectedApiHtmlQuery({ url: 10, lang: languageType });

  const pageBody = aboutUsHtml?.body?.[0]?.value ?? "No content available";

  const lastUpdatedOn = useMemo(
    () => getLastUpdatedOn(lastUpdatedOnData, 10),
    [lastUpdatedOnData],
  );

  useEffect(() => {
    const animateNumbers = () => {
      const elements = document.querySelectorAll(".stat-number");

      // First reset all numbers to 0
      elements.forEach((element) => {
        element.textContent = "0";
      });

      elements.forEach((element) => {
        const targetNumber = parseFloat(element.getAttribute("data-count"));
        const duration = 6000;
        const start = 0;
        const range = targetNumber - start;
        let startTime = null;

        const animate = (currentTime) => {
          if (!startTime) startTime = currentTime;
          const progress = Math.min((currentTime - startTime) / duration, 1);
          const currentValue = start + progress * range;
          element.textContent = Math.floor(currentValue).toString();
          if (progress < 1) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      });
    };

    animateNumbers();
  }, [aboutUsHtml]);

  if (aboutUsHtmlIsLoading || lastUpdatedIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={getText("About Us", "हमारे संबंध में")}
        titleTwo={innerBannerTitle}
        titleLink="/about-us/about-neepco"
        levelTwo={true}
        levelThree={false}
        isActive={innerBannerTitle}
      />
      <section className="inneraboutsection">
        <div className="inner-container">
          <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
        </div>
      </section>{" "}
      <div className="container mt-4">
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
      </div>
    </>
  );
};

export default AboutNeepcoPage;
